module.exports = __webpack_public_path__ + "img/SMT_06_Ms_Heidi_Rafman.836b2899.jpg";